/* eslint-disable */
import React, { FC, ReactElement, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import withLocalization from '../../components/hoc/withLocalization';
import OfferHeader from '../../components/common/OfferHeader/OfferHeader';
import PackageOverview from '../../components/PackageOverviewPage/PackageOverview';
import { RootState } from '../../redux/rootReducer';
import { logAnalyticData, offerType } from '../../analytics';
import UnifiedCheckout from '../../components/UnifiedCheckout/UnifiedCheckout';
import { analyticsData } from '../../analyticsTypes';
import './OfferPaymentDetails.scss';
import { getSiteIdentifier } from '../../util/SiteDetails';
import OfferStep from '../../components/common/BreadcrumbStep/OfferStep';

import { loadScriptInHead, removeDecimalPart } from '../../util/CommonLogic';

const PaymentDetailsContainer: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: `(max-width: 500px)` });
  const confirmationDetails = useSelector((state: RootState) => state.newOfferPaymentDetails.confirmationDetails);
  const pinofferDetails: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const prospectDetails: any = useSelector((state: RootState) => state.offerDetails.prospect);
  const pinInfoDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinDetails);

  const urlParams = useSelector((state: RootState) => state.pinOptFlowDetails.urlData);
  const offerData: any = (pinofferDetails?.offers && pinofferDetails?.offers[0]) || '';
  const roomType: any = (offerData?.roomTypes && offerData?.roomTypes[0]) || {};
  const retailVal = offerData?.retailValue || '';
  const retailPrice = roomType?.highSeasonRetailPrice || '';
  const updatedRetPrice = retailPrice || retailVal;
  const splitRetVal = updatedRetPrice?.split('$') || '';
  const refineRetPrice = removeDecimalPart(splitRetVal[1]) || '';
  const getofferPhone: any = offerData?.offerPhoneNumber || prospectDetails?.callCenterNumber;
  const PhoneNo = getofferPhone || '';
  const loc = offerData?.loc || '';
  const pin = pinInfoDetails?.pin || '';
  const offerDetailsInfo = offerData;
  const useUnifiedCheckout = process.env.REACT_APP_USE_UNIFIED_CHECKOUT?.toLowerCase() === 'true';
  const siteIdentifier = getSiteIdentifier();
  const title = localize('preview-sales-engine.static-content.copy.pbeo.payment-details-header');

  const errDetails = {
    errPhNo: PhoneNo || '',
    callCenterCode: prospectDetails?.callCenterCode,
    countryName: prospectDetails?.countryCode,
  };
  const handleLogAnalytics = (data: analyticsData) => {
    const roomType: any = (offerData?.roomTypes && offerData?.roomTypes[0]) || {};
    const stateCode = roomType?.property?.stateCode || '';
    const flowIdentifier = 'pin';
    const destination = urlParams?.destination;
    const brand =
      urlParams?.brand && urlParams?.brand.length > 0 ? urlParams?.brand : roomType?.property?.brandName || '';
    const offerCode = offerData?.offerCode || 'Vacation Offer';
    if (data.googleData) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: data.googleData.event,
        ecommerce: {
          currency: 'USD',
          value: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
          ...(data.googleData.otherData?.payment_type && { payment_type: data.googleData.otherData?.payment_type }),
          items: [
            {
              item_id: roomType?.property?.marshaCode,
              item_name: roomType?.property?.name,
              item_brand: brand,
              item_category: destination,
              item_category2: loc,
              item_category3: roomType?.property?.country || '',
              item_category4: stateCode,
              item_category5: roomType?.property?.city,
              item_category6: prospectDetails?.stateProvince,
              item_category7: offerType(offerData),
              item_category8: offerCode,
              item_category9: pin,
              price: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
              retail_price: refineRetPrice?.replace(/[$,]/g, '') || '',
              package_price: roomType?.startingCost?.replace(/[$,]/g, '') || '',
              flow_identifier: flowIdentifier,
              quantity: 1,
            },
          ],
        },
      });
    }
    if (data.adobeData) {
      logAnalyticData(
        {
          event: data.adobeData.event,
          siteSection: 'MVC ' + siteIdentifier + 'Optimized PBE',
          pageName: 'MVC ' + siteIdentifier + '| PBE Payment',
          pageHierarchy: '',
          server: 'MVC',
          website: 'MVC react',
          language: 'en',
        },
        {
          formLOC: loc,
          destination: destination,
          resortCity: roomType?.property?.city,
          resortState: stateCode,
          resortCountry: roomType?.property?.country || '',
          resortName: roomType?.property?.name,
          resortBrand: brand,
          offerCode: offerCode,
          offerType: offerType(offerData),
          flowIdentifier: flowIdentifier,
          retailPrice: refineRetPrice?.replace(/[$,]/g, '') || '',
          packagePrice: roomType?.startingCost?.replace(/[$,]/g, '') || '',
          depositPrice: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
          currency: 'USD',
          quanity: '1',
          resortMarsha: roomType?.property?.marshaCode,
          userSelectedState: prospectDetails?.stateProvince,
          bookingStepName: data.adobeData.bookingStepName,
          ...(data.adobeData.otherData?.paymentType && { paymentType: data.adobeData.otherData?.paymentType }),
        },
      );
    }
  };

  useEffect(() => {
    if (!offerDetailsInfo) {
      navigate('/error', { state: errDetails });
    }
    const analyticsData: analyticsData = {
      adobeData: {
        event: 'PbeAddPaymentInformation',
        bookingStepName: 'MVC | PBE Payment',
      },
    };
    handleLogAnalytics(analyticsData);
  }, []);

  useEffect(() => {
    const scriptUrl = process.env.REACT_APP_JSCRAMBLER_SCRIPT_URL;
    let scriptElement: any;

    if (scriptUrl) {
      loadScriptInHead(scriptUrl)
        .then((script) => {
          console.log('JSCRAMBLER Script added');
          scriptElement = script;
        })
        .catch(() => console.error('Failed to add the JSCRAMBLER script'));
    }

    // Cleanup on unmount
    return () => {
      if (scriptElement) {
        document.head.removeChild(scriptElement);
      }
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const confirmationStatus = confirmationDetails?.status?.toLowerCase() || '';
    const ConfirmationNumber = confirmationDetails?.ConfirmationNumber || '';
    if (
      confirmationStatus === 'success' ||
      confirmationStatus === 'pending' ||
      ConfirmationNumber ||
      confirmationDetails === 'no-details-available'
    ) {
      const getUrlSearchParam = sessionStorage.getItem('pinOptUrlSearchParam') || '';
      navigate('/thank-you' + getUrlSearchParam);
    }
  }, [confirmationDetails]);
  return (
    <>
      <OfferHeader phone={PhoneNo} isThankyou={false} />
      <div className="tmvc-payment-main-container">
        <div className="resevre-package-container">
          {!isMobile && <OfferStep title={title} />}
          <UnifiedCheckout logAnalytics={handleLogAnalytics} errPhoneNo={PhoneNo} />
        </div>
        <PackageOverview showSummaryDetails={!useUnifiedCheckout} />
        {isMobile && <OfferStep title={title} />}
      </div>
    </>
  );
};
export default withLocalization(PaymentDetailsContainer);
